import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const getDiagCodes = (search: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_DIAG_CODES_REQUEST });

  return api.authorization.diagCodes.get(search)
    .then((res: any) => {

      dispatch({
        type: types.GET_DIAG_CODES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_DIAG_CODES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
